export default "__VITE_ASSET__D329Gvtq__"